import { Link } from "react-router-dom";
import { Rocket } from "lucide-react";

export const CTASection = ({ title = "Ready to turn traffic into revenue?", subtitle = "Get a high-end, sales-focused website for $299. First-time customers save $50." }) => (
  <section className="mx-auto max-w-7xl px-6 my-20" data-testid="cta-section">
    <div className="relative overflow-hidden rounded-3xl glass p-10 md:p-16 text-center grid-bg">
      <div className="relative z-10 max-w-2xl mx-auto space-y-6">
        <h2 className="font-head text-3xl md:text-4xl font-extrabold">{title}</h2>
        <p className="text-muted-foreground text-base md:text-lg">{subtitle}</p>
        <div className="flex flex-wrap items-center justify-center gap-3">
          <Link to="/get-started" data-testid="cta-order-now"
            className="inline-flex items-center gap-2 rounded-full bg-primary text-primary-foreground px-7 h-12 font-semibold hover:brightness-110 transition-[filter] shadow-lg shadow-primary/30">
            <Rocket className="h-5 w-5" /> Get Started — from $299
          </Link>
        </div>
      </div>
    </div>
  </section>
);
